import { Component, OnInit } from '@angular/core';
import { FaturamentoService } from 'src/app/services/http/faturamento.service';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { FaturamentoDetalhado } from 'src/app/models/faturamento-detalhado';
import { LoginService } from 'src/app/services/login.service';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { Usuario } from 'src/app/models/usuario-login';

@Component({
  selector: 'app-faturamento',
  templateUrl: './faturamento.component.html',
  styleUrls: ['./faturamento.component.scss']
})
export class FaturamentoComponent implements OnInit {

  tableLoading: boolean = false;
  faturamentoDetalhado: FaturamentoDetalhado;
  total: number = 0;
  idFaturamentoFilhas: string = null;
  displayGerarFaturamento: boolean = false;
  novoFaturamento: NovoFaturamento = new NovoFaturamento();

  params = {
    filter: {
      // dataFim: '',
      // dataInicio: '',
      dataInicio: new Date(),
      dataFim: new Date(),
    },
    sorting: {
      id: 'desc',
      nome: '',
      dataCriacao: '',
    },
    data: new Date(),
    per_page: 10,
    page: 1
  }
  usuario: Usuario;

  constructor(private activedRoute: ActivatedRoute, private faturamentoService: FaturamentoService,private msgModal: ModalMsgService, private loginService: LoginService, private router: Router) {
    this.loginService.getLogIn().subscribe(l => this.usuario = l);
    this.novoFaturamento = new NovoFaturamento();
    this.novoFaturamento.clean();
  }

  ngOnInit() {
    if (!this.usuario.permissoes.faturamento_matriz && !this.usuario.permissoes.meu_faturamento) {
      this.router.navigate(['error/401'])
    }
    else {
      this.tableLoading = true;
      this.activedRoute.params.pipe(first()).subscribe(r => {
        this.idFaturamentoFilhas = r.idUnidade || null;
        if (this.idFaturamentoFilhas == null) {
          if (!this.usuario.permissoes.faturamento_matriz) {
            this.router.navigate(['error/401'])
          }
          else {
            this.faturamentoService.carregarFaturamento().then(result => {
              this.faturamentoDetalhado = result;
              this.tableLoading = false;
            });
          }
        } else {
          if (!this.usuario.permissoes.meu_faturamento) {
            this.router.navigate(['error/401'])
          }
          else {
            this.faturamentoService.carregarFaturamentoOutraEmpresa(this.idFaturamentoFilhas).then(result => {
              this.faturamentoDetalhado = result;
              this.tableLoading = false;
            });
          }
        }
      });
    }

  }

  toggleGerarFaturamento(){
    this.displayGerarFaturamento = !this.displayGerarFaturamento
    this.novoFaturamento.clean()
  }

  gerarNovoFaturamento(){
    if(this.novoFaturamento.isValid()){
      this.faturamentoService.gerarNovoFaturamento(this.usuario.unidade.uuid, this.novoFaturamento)
      .then(result => {
        this.ngOnInit();
        if(result != null || result != undefined){
          this.msgModal.openDialog('Sucesso', 'Novo faturamento ' + ' de ' +
          this.novoFaturamento.meses[this.novoFaturamento.mesReferente - 1].label+' de ' +
          this.novoFaturamento.anoReferente +' gerado com sucesso!', '', 'info');
        }
        else{
          this.msgModal.openDialog('Erro ao gerar novo faturamento', 'Faturamento não pode ser gerado, Verifique o problema com o suporte', '', 'danger');
        }
        this.toggleGerarFaturamento();
      })
      .catch(e => {
        this.msgModal.openDialog('Erro ao gerar novo faturamento',
          (e.error.toString().includes("existent billing") ? "Faturamento já existente para " +
          this.novoFaturamento.meses[this.novoFaturamento.mesReferente - 1].label + " de " +
          this.novoFaturamento.anoReferente + ", favor verificar o mes/ano referente" : 'Verifique o problema com o suporte'), 'danger');
        console.error(e)
      });
    }
    else {
      this.msgModal.openDialog('Alerta', 'Informe os campos necessários!', '', 'warning');
    }
  }

  deletarFaturamento(fatura){
    this.msgModal.openDialogQuestion('!!! ATENÇÃO !!!', 'Tem certeza que deseja deletar o Faturamento de ' + this.novoFaturamento.meses[fatura.mesRederencia-1].label + ' de ' + fatura.anoReferencia +'? \n Esse processo não pode ser revertido', '', 'danger')
    .then(resp => {
      if(resp != 'cancel'){
        if(fatura.totalClientesVerificados > 0){
          this.msgModal.openDialogQuestion('!!! ATENÇÃO !!!', 'Esse processo possuí ' + fatura.totalClientesVerificados + ' clientes já verificados que serão perdidos neste processo. \n Tem certeza que deseja continuar?', '', 'danger')
          .then(resp => {
            if(resp != 'cancel')
              this.deletarFatura(fatura);
          });
        } else {
          this.deletarFatura(fatura);
        }
      }
    });
  }

  deletarFatura(fatura){
    this.faturamentoService.deletarFaturamento(this.usuario.unidade.uuid, fatura.uuid)
    .then(result => {
      this.ngOnInit();
      if(result != null || result != undefined){
        this.msgModal.openDialog('Sucesso', 'Faturamento de '+ this.novoFaturamento.meses[fatura.mesRederencia-1].label + ' de ' + fatura.anoReferencia +' foi deletado com sucesso', '', 'info');
      } else{
        this.msgModal.openDialog('Erro ao deletar faturamento', 'Faturamento não pode ser deletado, Verifique o problema com o suporte', '', 'danger');
      }
    }).catch(e => {
      this.msgModal.openDialog('Erro ao gerar novo faturamento', 'Verifique o problema com o suporte', 'danger');
      console.error(e)
    });
  }
}

class NovoFaturamento{
  periodoFaturamento: string;
  mesReferente: number;
  anoReferente: number;
  periodos = [
    { label: 'MENSAL', value: "MENSAL" },
    { label: '1ª QUINZENA', value: "QUINZENAL1" },
    { label: '2ª QUINZENA', value: "QUINZENAL2" }
  ];
  meses = [
    { label: 'Janeiro', value: 1 },
    { label: 'Fevereiro', value: 2 },
    { label: 'Março', value: 3 },
    { label: 'Abril', value: 4 },
    { label: 'Maio', value: 5 },
    { label: 'Junho', value: 6 },
    { label: 'Julho', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Setembro', value: 9 },
    { label: 'Outubro', value: 10 },
    { label: 'Novembro', value: 11 },
    { label: 'Dezembro', value: 12 }
  ];

  clean(){
    this.periodoFaturamento = null;
    this.anoReferente = new Date().getFullYear();
    this.mesReferente = new Date().getMonth() + 1;
  }

  isValid(): boolean{
    return this.periodoFaturamento != null && this.anoReferente != null && this.mesReferente != null
  }
}
